import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  location: string;
  flag: string;
  quote: string;
  initials: string;
  color: string;
};
const testimonials: Testimonial[] = [{
  name: 'Carolina Méndez',
  role: 'Instructora de Pilates Reformer',
  location: 'Buenos Aires, Argentina',
  flag: '🇦🇷',
  quote: 'Compré el Megapack un domingo a la noche. El lunes entré al studio con la clase exacta planificada. Las clases del Tomo 1 son justo lo que necesitaba para mis grupos de principiantes. Nunca más improviso.',
  initials: 'CM',
  color: '#8B6FBF'
}, {
  name: 'Lucía Fernández',
  role: 'Studio Owner — Mat & Reformer',
  location: 'Madrid, España',
  flag: '🇪🇸',
  quote: 'Lo mejor que invertí este año. Las fichas clínicas me dieron seguridad para trabajar con alumnas con hernias y escoliosis. Ya no improviso, voy con un plan claro y profesional.',
  initials: 'LF',
  color: '#D4A574'
}, {
  name: 'Andrea Salas',
  role: 'Instructora certificada',
  location: 'Ciudad de México, México',
  flag: '🇲🇽',
  quote: 'Pensé que era "otro PDF más", pero esto es otro nivel. Los 6 tomos están organizados por objetivo y nivel — encuentro lo que necesito al instante. Por USD 19 es una ganga.',
  initials: 'AS',
  color: '#0F8B6F'
}, {
  name: 'Valentina Rojas',
  role: 'Instructora de Pilates Clínico',
  location: 'Santiago, Chile',
  flag: '🇨🇱',
  quote: 'La Guía de Variaciones en 3 Niveles eliminó el problema del grupo heterogéneo. Ahora muestro las 3 versiones de cada ejercicio y cada alumna elige la que le corresponde. Vale 10 veces lo que cuesta.',
  initials: 'VR',
  color: '#D98AA8'
}, {
  name: 'María José Castro',
  role: 'Instructora & Fisioterapeuta',
  location: 'Bogotá, Colombia',
  flag: '🇨🇴',
  quote: 'Los bloques para poblaciones especiales son oro puro. Trabajo con embarazadas y adultos mayores y por fin tengo material profesional confiable. El Script de Primera Clase me cambió la conversión.',
  initials: 'MC',
  color: '#8B6FBF'
}, {
  name: 'Sofía Aguirre',
  role: 'Instructora Reformer Avanzado',
  location: 'Lima, Perú',
  flag: '🇵🇪',
  quote: 'Lo descargué un viernes y el lunes ya estaba dando clases nuevas. Compatible con tablet, así que lo llevo al studio sin imprimir nada. La tasa de abandono de mis grupos bajó muchísimo.',
  initials: 'SA',
  color: '#D4A574'
}, {
  name: 'Daniela Herrera',
  role: 'Instructora Mat & Props',
  location: 'Quito, Ecuador',
  flag: '🇪🇨',
  quote: 'El Calendario Anual y las Playlists curadas me ahorran horas cada semana. Mis clases tienen ritmo profesional y mis alumnas lo notan. La inversión se pagó sola en la primera semana.',
  initials: 'DH',
  color: '#0F8B6F'
}, {
  name: 'Patricia Vargas',
  role: 'Instructora certificada',
  location: 'Montevideo, Uruguay',
  flag: '🇺🇾',
  quote: 'Después de 8 años dando clases sentía que repetía lo mismo. El Tomo III (Flow Dinámico) me dio frescura. Las alumnas avanzadas ahora se sienten desafiadas otra vez.',
  initials: 'PV',
  color: '#D98AA8'
}, {
  name: 'Isabella Romero',
  role: 'Instructora Pilates Reformer',
  location: 'San José, Costa Rica',
  flag: '🇨🇷',
  quote: 'Los protocolos para alumnas con hernias y osteoporosis son exactos: qué hacer, qué no hacer, qué decir. Ahora trabajo con tranquilidad y mis alumnas confían más en mí.',
  initials: 'IR',
  color: '#8B6FBF'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-297">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-298"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-299">
        <div className="text-center mb-10 sm:mb-14" data-id="element-300">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-301">
            ⭐ Testimonios reales
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-302">
            Instructoras de todo el mundo{' '}
            <span className="text-primary" data-id="element-303">hispanohablante</span> ya lo usan.
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4 flex-wrap" data-id="element-304">
            <span className="text-[#E0A52E] text-base sm:text-lg" data-id="element-305">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-306">
              4.9/5 · +800 reseñas verificadas en 9+ países
            </span>
          </div>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-307">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 shadow-[0_8px_24px_-12px_rgba(90,70,120,0.15)] flex flex-col relative" data-id="element-308">
              <span aria-hidden="true" className="absolute top-3 right-5 text-5xl font-black text-primary/15 leading-none select-none" data-id="element-309">
                "
              </span>

              <div className="flex items-center gap-2 mb-3" data-id="element-310">
                <span className="text-[#E0A52E] text-sm" data-id="element-311">⭐⭐⭐⭐⭐</span>
                <span className="text-xl" aria-hidden="true" data-id="element-312">
                  {t.flag}
                </span>
              </div>

              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium mb-5 flex-grow" data-id="element-313">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-314">
                <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-315">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-316">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-317">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-318">{t.role}</p>
                  <p className="text-text-sec text-xs truncate" data-id="element-319">
                    📍 {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm sm:text-base font-medium mt-10 sm:mt-12" data-id="element-320">
          Más de{' '}
          <span className="text-primary font-bold" data-id="element-321">15.000 instructoras</span> en
          todo el mundo hispanohablante ya enseñan con MEGAPACK PILATES LISTO.
        </p>
      </div>
    </section>;
}